import TerminalWindow from './TerminalWindow'
import useTerminal from '../models/useTerminal'

export default function TerminalManager() {
  const { sessions, setMode, requestClose, focusSession, setPosition, setSize } = useTerminal()

  return (
    <>
      {sessions.map(session => (
        <TerminalWindow
          key={session.id}
          session={session}
          isActive={session.isActive}
          hidden={session.mode === 'minimized'}
          onClose={() => requestClose(session.id)}
          onExpand={() => focusSession(session.id, 'fullscreen')}
          onReduce={() => focusSession(session.id, 'modal')}
          onMinimize={() => setMode(session.id, 'minimized')}
          onFocus={() => focusSession(session.id)}
          onPositionChange={position => setPosition(session.id, position)}
          onSizeChange={size => setSize(session.id, size)}
        />
      ))}
    </>
  )
}
